<template>
  <div>
    <main-table
      :data="data.tabledata"
      :show-page="false"
      :show-search="false"
      :show-page-size="false"
      >
      <template v-slot:name="scope">
        <el-link :underline="false" type="primary" @click="clickCompany(scope.row.id)">{{ scope.row.name }}</el-link>
      </template>
      <template v-slot:supplierName="scope">
        <el-link :underline="false" type="primary" @click="clickCompany(scope.row.supplierId)">{{ scope.row.supplierName }}</el-link>
      </template>
      <template v-slot:buyerName="scope">
        <el-link :underline="false" type="primary" @click="clickCompany(scope.row.buyerId)">{{ scope.row.buyerName }}</el-link>
      </template>
    </main-table>
    <el-button plain @click="checkMore">{{ $i18.language("查看更多") }}</el-button>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {return {}}
    }
  },
  data() {
    return {
      localhost: this.$util.getCurrentWebSiteByProduct(),
    };
  },
  created() {
  },
  methods: {
    checkMore(){
      let tradeType= `tabCheck=${this.data.moreType}&uniqueKey=${this.data.uniqueKey}`
      let companyType = `tabCheck=${this.data.moreType}&where=businessDetail&uniqueKey=${this.data.uniqueKey}`
      if (this.data.dataType == 3) {
        window.open(`${this.localhost}/trade/result?${tradeType}&wlf=ai_gpt`)
      } else {
        window.open(`${this.localhost}/company/result?${companyType}&wlf=ai_gpt`)
      }
    },
    clickCompany(val){
      window.open(this.localhost + `/company/detail/${val}/0?wlf=ai_gpt`)
    },
  },
};
</script>

<style scoped lang="scss">
.el-button {
  margin-top: 8px;
  border-radius: 6px;
  &:hover, &:focus {
    color: $--color-link;
    border: 1px solid $--color-link;
  }
}
/deep/ .el-link--inner {
  color: $--color-link;
  &:hover {
    color: $--color-link;
  }
}
</style>
